import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';
import MeetingsManager from '../../../components/admin/appointments/MeetingsManager';

function AdminMeetingsPage() {
  return (
    <AdminLayout title="Agenda Équipe">
      <MeetingsManager showUserFilter={true} />
    </AdminLayout>
  );
}

export default AdminMeetingsPage;
